module.exports = __webpack_public_path__ + "img/img112.c948a2b7.svg";